import agent from "../Service/agent";
import {
    CONTACT_ERROR_MESSAGE,
    CONTACT_ERROR_MESSAGE_CLEAR,
    CONTACT_PENDING,
    CONTACT_SUCCESS,
    CONTACT_SUCCESS_CLEAR
} from "./constants";

export const contactPending = () => ({
    type: CONTACT_PENDING
})
export const contactSuccess = () => ({
    type: CONTACT_SUCCESS
})
export const contactErrorMessage = (errroMessage) => ({
    type: CONTACT_ERROR_MESSAGE,
    payload: { errroMessage }
})
export const contactErrorMessageClear = () => ({
    type: CONTACT_ERROR_MESSAGE_CLEAR
})
export const contactSuccessClear = () => ({
    type: CONTACT_SUCCESS_CLEAR
})

export const sendMessage = (data) => (dispatch) => {
    dispatch(contactPending());
    return agent.contact.sendMessage(data)
        .then(() => {
            dispatch(contactSuccess());
            dispatch(contactErrorMessageClear());
            // return Promise.resolve();
        })
        .catch((err) => {
            if (err && err.response) {
                const { text } = err.response;
                console.log("err.response: ", err.response)
                dispatch(contactErrorMessage(text))
            }
        })
}
